import { ActionTaken } from '@utils-global';

export const ACTION_OPTIONS = [
  { value: ActionTaken.VISITED_LINK, translationKey: 'reportPage.v2.options.visited_link' },
  { value: ActionTaken.REPLIED_TO_EMAIL, translationKey: 'reportPage.v2.options.replied_to_email' },
  { value: ActionTaken.DOWNLOADED_FILE, translationKey: 'reportPage.v2.options.downloaded_file' },
  {
    value: ActionTaken.OPENED_ATTACHMENT,
    translationKey: 'reportPage.v2.options.opened_attachment',
  },
  { value: ActionTaken.ENTERED_PASSWORD, translationKey: 'reportPage.v2.options.entered_password' },
  {
    value: ActionTaken.ENTERED_OTHER_DATA,
    translationKey: 'reportPage.v2.options.entered_other_data',
  },
  { value: ActionTaken.FORWARDED_EMAIL, translationKey: 'reportPage.v2.options.forwarded_email' },
] as const;
